/**
 * 剪辑工程 store（D-14 链路）。让"故事板/画布 → 导出到剪辑"能把工程推进来、剪辑页读取打开。
 * 项目列表为运行期内存态（工程数据本身本地 SQLite/草稿持久化，见 editing.saveDraft）。
 */
import { create } from 'zustand';

import { MOCK_PROJECTS, type EditProject } from '../model/editing';

interface EditingState {
  projects: EditProject[];
  addProject: (p: EditProject) => void;
}

export const useEditingStore = create<EditingState>()((set) => ({
  projects: MOCK_PROJECTS,
  addProject: (p) => set((s) => ({ projects: [p, ...s.projects] })),
}));
